import { REACT_APP__CARROT_EVENTS_ROUTE } from "@smp/utils";
import { PropsWithChildren, useCallback, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useContextSupportMessenger } from "@/context/support_messenger";

export const ProviderEvents = ({ children }: PropsWithChildren<{}>) => {
  const {
    actions: { carrotTrack },
  } = useContextSupportMessenger();

  const location = useLocation();

  const carrotEvents = useMemo(() => {
    const carrotEvents: { [key: string]: string } = {};
    try {
      const arr: [string, string][] = JSON.parse(
        REACT_APP__CARROT_EVENTS_ROUTE,
      );
      for (let item of arr) {
        carrotEvents[item[0]] = item[1];
      }
    } catch (error) {
      console.error(error);
    }
    return carrotEvents;
  }, []);

  const trackRoute = useCallback(
    (eventName: string) => {
      carrotTrack && carrotTrack(`Переход: ${eventName}`, {});
    },
    [carrotTrack],
  );

  useEffect(() => {
    if (!carrotEvents) return;

    const eventName = carrotEvents[location.pathname];
    if (eventName) {
      trackRoute(eventName);
    }
  }, [location.pathname, carrotEvents, trackRoute]);

  return <>{children}</>;
};
